// eslint-disable-next-line import/prefer-default-export
export const SET_MAGAZINE = 'MAGAZINE/SET_MAGAZINE'
